import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import DetailsWorker from './details'
import '../pages.styles.scss'

class PageDetails extends React.Component {

    constructor(props) {
        super(props)
        this.detailsWorker = DetailsWorker(this)
        this.state = this.detailsWorker.getDefaultState()
    }

    componentDidMount() {
        this.detailsWorker.loadPage()
    }

    getTypeLabel = (type) => {
        switch (Number(type)) {
            case 0:
                return 'SYSTEM'
            case 1:
                return 'NEWS'
            default:
                return type
        }
    }

    render() {
        const page = this.state.page

        return (
            <div className="page-details">
                {
                    this.state.loadingPage && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/pages">Pages</Link>
                    <div className="header">
                        <h4>Page Details</h4>
                    </div>

                    <div className={"flag " + this.state.flag.type}>{this.state.flag.text}</div>

                    {
                        page && (
                            <div className="details-grid">
                                <div><strong>ID:</strong> {page.id}</div>
                                <div><strong>Title:</strong> {page.title}</div>
                                <div><strong>Type:</strong> {this.getTypeLabel(page.type)}</div>
                                <div><strong>URL:</strong> {page.url || '-'}</div>
                                <div><strong>Keywords:</strong> {page.keywords || '-'}</div>
                                <div><strong>Description:</strong> {page.description || '-'}</div>
                                <div><strong>Thumbnail:</strong> {page.thumbnail || '-'}</div>
                                <div><strong>Created:</strong> {(page.createdAt || page.created) ? new Date(page.createdAt || page.created).toLocaleString() : '-'}</div>
                                <div><strong>Updated:</strong> {(page.updatedAt || page.updated) ? new Date(page.updatedAt || page.updated).toLocaleString() : '-'}</div>
                                <div className="body-block">
                                    <strong>Body</strong>
                                    <div className="body-content" dangerouslySetInnerHTML={{ __html: page.body || '' }} />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(PageDetails)
